import { useQuery, useQueryCache } from '@zoomcatalog/query-client';
import { AxiosError } from 'axios';
import api from '@/config/axios';
import { USER_GET } from '@/config/endpoints';
import { IUser } from '@/service/ts-definitions';
import { useSelector } from '@/store/rootStore';

type UserQueryContext = {
  handlers?: {
    onSuccess?(data: IUser): void;
  };
};
export function useUserQuery(context?: UserQueryContext) {
  const endpoints = useSelector((state) => state.sniffer.endpoints);

  return useQuery<IUser, AxiosError>('user', {
    queryFn: async () =>
      api
        .get<IUser>(USER_GET.endpoint, {
          baseURL: endpoints.value.USERS_API_ENDPOINT,
        })
        .then((data) => data.data),
    onSuccess(data) {
      context?.handlers?.onSuccess?.(data);
    },
    staleTime: Infinity,
    refetchOnMount: false,
  });
}

export function useInvalidateUserQuery() {
  const cache = useQueryCache();
  return async () => cache.invalidateQueries('user');
}
